import { useNonEntityMutation } from '@melio/api-client';
import { ApiKeys, VexFTIApiClient } from '@melio/platform-api-axios-client';

export const useCompleteVendorOnboarding = () =>
  useNonEntityMutation(
    ({ onboardingSessionUuid, organizationId }: { organizationId: string; onboardingSessionUuid: string }) =>
      VexFTIApiClient.postOrganizationRegisterToFtiBySessionUuid(organizationId, onboardingSessionUuid),
    [ApiKeys.VexFTIApi, 'collection', 'postOrganizationRegisterToFtiBySessionUuid']
  );
